/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import { Link } from 'react-router-dom';
import React, { Suspense, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from 'react-bootstrap/Navbar';
import { TickerTape } from 'react-ts-tradingview-widgets';
import TopNavBar from '../../utils/topNavBar';
import Footer from './footerSmall';
import TickerTapeSymbols from '../../utils/stocksListWidget';
import FAQData from '../../API/data/faqData';
import { eventData, returnData, teamData } from '../../API/data/chooseUsData';
import {
  googleRatingList1,
  googleRatingList2,
  googleRatingList3,
} from '../../API/data/testimonialsData';
import SpinnerLoader from '../../animations/spinnerLoader';
import PastPerformanceBar from '../../utils/pastPerformanceBar';

const ImageSlider = React.lazy(() => import('../../utils/imageSlider'));
const DiscoverPlans = React.lazy(() => import('./discoverPlans'));

function Accordion({ title, content, hrefLink, hrefLabel }) {
  const [isActive, setIsActive] = useState(false);

  const toggleAccordion = () => {
    setIsActive(!isActive);
  };

  return (
    <div className='mb-2'>
      <button
        className={`accordionTab ${isActive ? 'activeTab' : ''}`}
        onClick={toggleAccordion}
        type='button'
      >
        {title}
      </button>
      <div className='panel' style={{ maxHeight: isActive ? '500px' : '0' }}>
        <p className='text-white pb-2'>
          {content}
          <a className='text-decoration-underline text-white' href={hrefLink}>
            {hrefLabel}
          </a>
        </p>
      </div>
    </div>
  );
}

function HomePage() {
  const pageTitle =
    'Stock Advisory Company - Stock Recommendation Intraday | Intelisys';
  const pageDescription =
    'Our analysts provide the best Stock Recommendations Intraday about the Indian stock market and is the best Stock Advisory Company Get free tips from intelisys now.';

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>{pageTitle}</title>
        <meta name='description' content={pageDescription} />
        <meta property='og:title' content={pageTitle} />
        <meta property='og:description' content={pageDescription} />
      </Helmet>
      <TopNavBar />
      <div>
        <div className='d-flex'>
          <div className='d-flex justify-content-lg-center col-lg-6 ps-lg-5 ps-3 pt-3 my-auto'>
            <div>
              <h1 className='text-start'>
                <span className='text-black fw-bold'>Buy/Sell for </span>
                <span className='int-text-green fw-bold'>Profits.</span>
                <br />
                <span className='text-black fw-bold'>with </span>
                <span className='int-text fw-bold'>Intelisys.</span>
              </h1>
              <p
                className='text-black mt-4 me-2 lead fs-5 fw-semibold'
                style={{ textAlign: 'justify' }}
              >
                SEBI Reg. Advisory
              </p>
              <Link to='/view-all-plans'>
                <button
                  className='btn text-nowrap int-bg btn-sm fs-5 text-white mt-5 mb-5 px-3'
                  type='button'
                >
                  Get Started
                </button>
              </Link>
            </div>
          </div>
          <div
            className='col-lg-6 align-items-center justify-content-center d-none d-md-flex '
            style={{
              backgroundImage: 'url("./images/bgImage.webp")',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              height: '90vh',
            }}
          >
            <img
              className='img-fluid w-50 pt-5'
              src='./images/GraphTrade.webp'
              alt='stock market tips'
            />
          </div>
        </div>
        <div className='text-center d-block d-md-none'>
          <img
            className='img-fluid w-75'
            src='./images/GraphTradeMobile.webp'
            alt='stock market tips'
          />
        </div>
      </div>
      <div style={{ backgroundColor: '#EEF7FD' }}>
        <div className='container py-5'>
          <h1 className='text-center'>Highlights</h1>
          <div className='d-flex flex-wrap pt-5'>
            <div className='col-12 col-lg-6 order-lg-2 text-center'>
              <img
                className='img-fluid'
                src='./images/Highlights_Img.webp'
                alt='stock market tips'
              />
            </div>
            <div className='col-12 col-lg-6 order-lg-1 justify-content-between d-flex flex-column'>
              <div className='d-flex mt-4 align-items-center'>
                <img
                  className='img-fluid me-3'
                  style={{ width: 42, height: 42 }}
                  src='./images/Highlight_1.webp'
                  alt='stock market tips'
                />
                <p style={{ fontSize: 20, fontWeight: 500, color: '#000' }}>
                  Avail Live trades For Profits with Proper Target, Stop loss
                  and Timely Updates
                </p>
              </div>
              <div className='d-flex mt-4 align-items-center'>
                <img
                  className='img-fluid me-3'
                  style={{ width: 42, height: 42 }}
                  src='./images/Highlight_2.webp'
                  alt='stock market tips'
                />
                <p style={{ fontSize: 20, fontWeight: 500, color: '#000' }}>
                  Support and Resistance for Self Trade
                </p>
              </div>

              <div className='d-flex mt-4 align-items-center'>
                <img
                  className='img-fluid me-3'
                  style={{ width: 42, height: 42 }}
                  src='./images/Highlight_3.webp'
                  alt='stock market tips'
                />
                <p style={{ fontSize: 20, fontWeight: 500, color: '#000' }}>
                  Customize your Own Plans
                </p>
              </div>
              <div className='d-flex mt-4 align-items-center'>
                <img
                  className='img-fluid me-3'
                  style={{ width: 42, height: 42 }}
                  src='./images/Highlight_4.webp'
                  alt='stock market tips'
                />
                <p style={{ fontSize: 20, fontWeight: 500, color: '#000' }}>
                  Buy Single Live Trade
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className='container py-5'>
          <h1 className='text-center'>Live Call Journey Video</h1>
          <div className='d-flex flex-wrap pt-5'>
            <div className='col-12 col-lg-6 text-center'>
              <iframe
                src='https://www.youtube.com/embed/3po5VB2tRaU?si=NC2OwYN11ATE8oc5'
                frameBorder='0'
                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen
                title='Embedded youtube'
                style={{ width: '100%', height: '100%' }}
              />
            </div>
            <div className='col-12 col-lg-6 d-flex flex-column align-items-center mt-4 mt-lg-0'>
              <div className='d-flex align-items-center'>
                <img
                  className='img-fluid me-3'
                  style={{ width: 42, height: 42 }}
                  src='./images/signal-tower.webp'
                  alt='stock market tips'
                />
                <p style={{ fontSize: 20, fontWeight: 500, color: '#000' }}>
                  Trade Signals
                </p>
              </div>
              <p
                style={{
                  fontSize: 47,
                  marginTop: 30,
                  fontWeight: 500,
                  color: '#000',
                }}
              >
                +
              </p>
              <div className='d-flex align-items-center mt-3 mt-lg-0'>
                <div className='col-lg-2' />
                <div className='col-6 col-lg-4'>
                  <div className='d-flex align-items-center'>
                    <img
                      className='img-fluid me-3'
                      style={{ width: 42, height: 42 }}
                      src='./images/clock.webp'
                      alt='stock market tips'
                    />
                    <p className='int-fs-16 text-black'>Real time updates</p>
                  </div>
                  <div className='d-flex align-items-center mt-4'>
                    <img
                      className='img-fluid me-3'
                      style={{ width: 42, height: 42 }}
                      src='./images/calendar-1.webp'
                      alt='stock market tips'
                    />
                    <p className='int-fs-16 text-black'>Regular updates</p>
                  </div>
                  <div className='d-flex align-items-center  mt-4'>
                    <img
                      className='img-fluid me-3'
                      style={{ width: 42, height: 42 }}
                      src='./images/speedmeter.webp'
                      alt='stock market tips'
                    />
                    <p className='int-fs-16 text-black'>
                      Well Maintained Performance Reports
                    </p>
                  </div>
                </div>
                <div className='col-6 col-lg-5'>
                  <img
                    className='img-fluid'
                    src='./images/trophy.webp'
                    alt='stock market tips'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: '#EEF7FD' }}>
        <div className='container py-5'>
          <h1 className='text-center'>Why choose us ?</h1>
          <Suspense fallback={<SpinnerLoader isLoading />}>
            <ImageSlider images={teamData} />
            <ImageSlider images={returnData} />
            <ImageSlider images={eventData} />
          </Suspense>
        </div>
      </div>
      <Suspense fallback={<SpinnerLoader isLoading />}>
        <DiscoverPlans />
      </Suspense>
      <div style={{ backgroundColor: '#356CAE' }}>
        <div className='d-lg-flex d-block container py-5'>
          <div className='col-12 col-lg-4 d-flex align-items-center justify-content-start justify-content-lg-center'>
            <img
              className='img-fluid'
              src='./images/100_Secure.webp'
              style={{ height: 90, width: 90 }}
              alt='stock market tips'
            />
            <span
              className='int-fs-25 text-white fw-normal ms-4'
              style={{
                fontFamily: 'Pattaya, sans-serif',
                fontStyle: 'normal',
                letterSpacing: 1.68,
                lineHeight: 'normal',
              }}
            >
              100% Secure
            </span>
          </div>
          <div className='col-12 col-lg-4 d-flex align-items-center justify-content-start justify-content-lg-center my-4 my-lg-0'>
            <img
              className='img-fluid'
              src='./images/75_accuracy.webp'
              style={{ height: 90, width: 90 }}
              alt='stock market tips'
            />
            <span
              className='int-fs-25 text-white fw-normal ms-4'
              style={{
                fontFamily: 'Pattaya, sans-serif',
                fontStyle: 'normal',
                letterSpacing: 1.68,
                lineHeight: 'normal',
              }}
            >
              75%+ Accuracy
            </span>
          </div>
          <div className='col-12 col-lg-4 d-flex align-items-center justify-content-start justify-content-lg-center'>
            <img
              className='img-fluid'
              src='./images/award_winning_advisory.webp'
              style={{ height: 90, width: 90 }}
              alt='stock market tips'
            />
            <span
              className='int-fs-25 text-white fw-normal ms-4'
              style={{
                fontFamily: 'Pattaya, sans-serif',
                fontStyle: 'normal',
                letterSpacing: 1.68,
                lineHeight: 'normal',
              }}
            >
              Award Winning Advisory
            </span>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: '#356CAE' }}>
        <div className='container pb-4'>
          <h1 className='text-white pb-2'>Past Performance Report</h1>
          <div className='d-flex flex-wrap justify-content-lg-between align-items-center'>
            <div className='col-12 col-lg-6 d-lg-flex flex-wrap justify-content-between'>
              <div className='performance-card mx-lg-2 my-2 bg-white p-2 rounded'>
                <div className='d-flex justify-content-between'>
                  <i className='bi bi-stack fs-5' />
                  <h4 className='text-black'>6607</h4>
                </div>
                <p className='text-black '>Total Calls</p>
              </div>
              <div className='performance-card mx-lg-2 my-2 bg-white p-2 rounded'>
                <div className='d-flex justify-content-between'>
                  <i className='bi bi-bar-chart-line fs-5' />
                  <h4 className='text-black'>75%</h4>
                </div>
                <p className='text-black '>Success Rate/Call Accuracy</p>
              </div>
              <div className='performance-card mx-lg-2 my-2 bg-white p-2 rounded'>
                <div className='d-flex justify-content-between'>
                  <i className='bi bi-currency-rupee fs-5' />
                  <h4 className='text-black'>10,40,281</h4>
                </div>
                <p className='text-black '>Last Month Profit</p>
              </div>
              <div className='performance-card mx-lg-2 my-2 bg-white p-2 rounded'>
                <div className='d-flex justify-content-between'>
                  <i className='bi bi-currency-rupee fs-5' />
                  <h4 className='text-black'>2,50,18,545</h4>
                </div>
                <p className='text-black '>Profit Till Today Since Start</p>
              </div>
              <div className='performance-card mx-lg-2 my-2 bg-white p-2 rounded'>
                <div className='d-flex justify-content-between'>
                  <i className='bi bi-graph-up fs-5' />
                  <h4 className='text-black'>6.58%</h4>
                </div>
                <p className='text-black '>Last Month Returns</p>
              </div>
              <div className='performance-card mx-lg-2 my-2 bg-white p-2 rounded'>
                <div className='d-flex justify-content-between'>
                  <i className='bi bi-graph-up fs-5' />
                  <h4 className='text-black'>158.04%</h4>
                </div>
                <p className='text-black '>Annual Returns</p>
              </div>
            </div>
            <div className='col-12 col-lg-6 text-center px-lg-4'>
              <PastPerformanceBar />
            </div>
          </div>
        </div>
      </div>
      <div style={{ backgroundColor: '#3C86DD' }}>
        <div className='container py-5'>
          <h1 className='text-white'>Testimonials</h1>
          <div className='d-flex overflow-auto'>
            <div className='col-12 col-lg-4'>
              <div
                aria-hidden
                onClick={() =>
                  window.open(
                    'https://www.google.com/search?gs_ssp=eJzj4tVP1zc0zEoyzzA0NiszYLRSNagwTko2SjY0MUtNNjGzSDI2tjKoSEpLNjVOMTMytDA0SExNTfSSyswrSc3JLK4sVihLzSspLUotVigoK1HIKUkBAMv5GaU&q=intelisys+ventures+pvt+ltd&rlz=1C1CHBF_enIN998IN998&oq=Intelisysven&aqs=chrome.1.69i57j46i13i175i199i512j0i390l2.5372j0j7&sourceid=chrome&ie=UTF-8#lrd=0x3bc2c146ec468b33:0xbfc53d621810aeea,1,,,,',
                    '_blank'
                  )
                }
                className='card m-3 bg-light p-3'
                style={{ cursor: 'pointer' }}
              >
                <div className='d-flex justify-content-between align-items-center'>
                  <div>
                    <div>
                      <span className='text-primary fs-3 fw-semibold'> G</span>
                      <span className='text-danger fs-3 fw-semibold'>o</span>
                      <span className='text-warning fs-3 fw-semibold'>o</span>
                      <span className='text-primary fs-3 fw-semibold'>g</span>
                      <span className='text-success fs-3 fw-semibold'>l</span>
                      <span className='text-danger fs-3 fw-semibold'>e</span>
                    </div>
                    <div>
                      <span>Reviews </span>
                      <i
                        className='bi bi-star-fill'
                        style={{ color: '#FEC600' }}
                      />
                      <i
                        className='bi bi-star-fill'
                        style={{ color: '#FEC600' }}
                      />
                      <i
                        className='bi bi-star-fill'
                        style={{ color: '#FEC600' }}
                      />
                      <i
                        className='bi bi-star-fill'
                        style={{ color: '#FEC600' }}
                      />
                      <i
                        className='bi bi-star-fill'
                        style={{ color: '#FEC600' }}
                      />
                    </div>
                  </div>
                  <div>
                    <h3 className='m-0'>5K+</h3>
                    <p>Reviews</p>
                  </div>
                </div>
              </div>
              {googleRatingList1.map((items, index) => (
                <a href={items.Link} key={index} target='blank'>
                  <div className='card m-3 bg-light p-3' key={index}>
                    <div className='d-flex align-items-center justify-content-start'>
                      <img
                        className='img-fluid'
                        src={items.ProfileImage}
                        style={{ height: 60, width: 60, borderRadius: 60 }}
                        alt='stock market tips'
                      />
                      <span
                        className='int-fs-20 text-black ms-4'
                        style={{
                          fontWeight: '500',
                          fontStyle: 'normal',
                          letterSpacing: 1.68,
                          lineHeight: 'normal',
                        }}
                      >
                        {items.Name}
                      </span>
                    </div>
                    <p className='text-black mt-3'>{items.Description}</p>
                  </div>
                </a>
              ))}
            </div>
            <div className='col-12 col-lg-4'>
              {googleRatingList2.map((items, index) => (
                <a href={items.Link} key={index} target='blank'>
                  <div className='card m-3 bg-light p-3' key={index}>
                    <div className='d-flex align-items-center justify-content-start'>
                      <img
                        className='img-fluid'
                        src={items.ProfileImage}
                        style={{ height: 60, width: 60, borderRadius: 60 }}
                        alt='stock market tips'
                      />
                      <span
                        className='int-fs-20 text-black ms-4'
                        style={{
                          fontWeight: '500',
                          fontStyle: 'normal',
                          letterSpacing: 1.68,
                          lineHeight: 'normal',
                        }}
                      >
                        {items.Name}
                      </span>
                    </div>
                    <p className='text-black mt-3'>{items.Description}</p>
                  </div>
                </a>
              ))}
              <div className='card m-3 bg-light p-3'>
                <a
                  href='https://www.youtube.com/c/IntelisysInvestmentAndTrading'
                  target='blank'
                >
                  <div className='d-flex justify-content-between align-items-center'>
                    <div className='col-12'>
                      <div className='rounded int-bg-red p-2 text-center'>
                        <span className='text-white'>150K Subscribers</span>
                      </div>
                      <p className='text-black text-center mt-2'>
                        Subscribe to our YouTube Channel
                      </p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div className='col-12 col-lg-4'>
              <div className='card m-3 bg-light p-3'>
                <a href='https://telegram.me/Intelisys' target='blank'>
                  <div className='d-flex justify-content-between align-items-center'>
                    <div className='col-2'>
                      <img
                        className='img-fluid'
                        src='./images/telegramLogo.webp'
                        alt='stock market tips'
                      />
                    </div>
                    <div className='px-3'>
                      <span className='int-fs-16 fw-semibold int-text-dark'>
                        Free Telegram Channel
                      </span>
                    </div>
                    <div>
                      <h3 className='m-0 int-text-dark'>40K+</h3>
                      <p className='int-text-dark'>Members</p>
                    </div>
                  </div>
                </a>
              </div>
              {googleRatingList3.map((items, index) => (
                <a href={items.Link} key={index} target='blank'>
                  <div className='card m-3 bg-light p-3' key={index}>
                    <div className='d-flex align-items-center justify-content-start'>
                      <img
                        className='img-fluid'
                        src={items.ProfileImage}
                        style={{ height: 60, width: 60, borderRadius: 60 }}
                        alt='stock market tips'
                      />
                      <span
                        className='int-fs-20 text-black ms-4'
                        style={{
                          fontWeight: '500',
                          fontStyle: 'normal',
                          letterSpacing: 1.68,
                          lineHeight: 'normal',
                        }}
                      >
                        {items.Name}
                      </span>
                    </div>
                    <p className='text-black mt-3'>{items.Description}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
          <h6 className='text-center fw-normal mt-3'>
            <a
              href='https://www.google.com/search?gs_ssp=eJzj4tVP1zc0zEoyzzA0NiszYLRSNagwTko2SjY0MUtNNjGzSDI2tjKoSEpLNjVOMTMytDA0SExNTfSSyswrSc3JLK4sVihLzSspLUotVigoK1HIKUkBAMv5GaU&q=intelisys+ventures+pvt+ltd&rlz=1C1CHBF_enIN998IN998&oq=Intelisysven&aqs=chrome.1.69i57j46i13i175i199i512j0i390l2.5372j0j7&sourceid=chrome&ie=UTF-8#lrd=0x3bc2c146ec468b33:0xbfc53d621810aeea,1,,,,'
              target='_blank'
              rel='noreferrer'
              className='text-white int-fs-17'
            >
              view all reviews
            </a>
          </h6>
        </div>
      </div>
      <div className='reward p-lg-5 p-3'>
        <div
          className='container col-12 col-lg-9 d-flex flex-lg-row flex-column p-lg-5 p-3 justify-content-between'
          style={{ backgroundColor: 'rgba(60, 134, 221, 0.10)' }}
        >
          <div className='col-12 col-lg-7 justify-content-between d-flex flex-column'>
            <h5 className='int-fs-25' style={{ color: '#356CAE' }}>
              Take the first step towards financial success.
            </h5>
            <div>
              <button
                type='button'
                className='btn text-white rounded-1 align-self-start d-none d-lg-block'
                style={{ backgroundColor: '#3C86DD' }}
                onClick={() =>
                  window.open(
                    'https://chat.whatsapp.com/L8anwSIGgDW5pB0aXRRu0X',
                    '_blank'
                  )
                }
              >
                Join Our Premium MCX WhatsApp Community
              </button>
              <button
                type='button'
                className='btn text-white rounded-1 align-self-start d-none d-lg-block mt-3'
                style={{ backgroundColor: '#3C86DD' }}
                onClick={() =>
                  window.open(
                    'https://chat.whatsapp.com/FbEI0Tf7cTaLg7UsMpVPPF',
                    '_blank'
                  )
                }
              >
                Join Our Premium Nifty And Bank Nifty WhatsApp Community
              </button>
            </div>
          </div>
          <div className='col-lg-4 col-8 align-self-end'>
            <img
              className='img-fluid'
              src='./images/gold-winner-trophy.webp'
              alt='stock market tips'
            />
          </div>
        </div>
        <div className='d-flex flex-column d-lg-none align-items-center mt-3'>
          <button
            type='button'
            className='btn text-white rounded-1 w-75'
            onClick={() =>
              window.open(
                'https://chat.whatsapp.com/L8anwSIGgDW5pB0aXRRu0X',
                '_blank'
              )
            }
            style={{ backgroundColor: '#3C86DD' }}
          >
            Join Our Premium MCX WhatsApp Community
          </button>
          <button
            type='button'
            className='btn text-white rounded-1 w-75 mt-3'
            onClick={() =>
              window.open(
                'https://chat.whatsapp.com/FbEI0Tf7cTaLg7UsMpVPPF',
                '_blank'
              )
            }
            style={{ backgroundColor: '#3C86DD' }}
          >
            Join Our Premium Nifty And Bank Nifty WhatsApp Community
          </button>
        </div>
      </div>
      <div className='py-lg-5 py-3' style={{ backgroundColor: '#EEF7FD' }}>
        <div className='container'>
          <h5 className='text-lg-start text-center' style={{ fontSize: 36 }}>
            FAQs
          </h5>
          <div className=' d-lg-flex align-items-center'>
            <div className='col-12 col-lg-6 order-lg-2 text-lg-end text-center py-lg-0 py-4'>
              <img
                className='img-fluid w-75'
                src='./images/FAQs.webp'
                alt='faq'
              />
            </div>
            <div className='col-12 col-lg-6 order-lg-1'>
              {FAQData.map((data, index) => (
                <Accordion
                  key={index}
                  title={data.heading}
                  content={data.content}
                  hrefLink={data.hrefLink}
                  hrefLabel={data.hrefLabel}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* <div className='py-lg-5 py-3'>
        <div className='container'>
          <h5 className='text-lg-start text-center int-fs-28 fw-semibold'>
            Join Free Telegram Channel
          </h5>
          <div className=' d-lg-flex align-items-center'>
            <div className='col-12 col-lg-5 order-lg-2 text-center text-lg-end py-lg-0 py-4'>
              <img
                className='img-fluid'
                src='./images/telegramLogo.webp'
                alt='faq'
              />
            </div>
            <div className='col-12 col-lg-6 order-lg-1'>
              <div className='d-flex align-items-center  mt-4'>
                <img
                  className='img-fluid me-3'
                  style={{ width: 42, height: 42 }}
                  src='./images/calendar.webp'
                  alt='stock market tips'
                />
                <p className='int-text-darkblue int-fs-17'>
                  Get Live Trade Updates
                </p>
              </div>
              <div className='d-flex align-items-center mt-4'>
                <img
                  className='img-fluid me-3'
                  style={{ width: 42, height: 42 }}
                  src='./images/bell.webp'
                  alt='stock market tips'
                />
                <p className='int-text-darkblue int-fs-17'>
                  Notified Timely for Profit Booking of Your Purchase
                </p>
              </div>
            </div>
          </div>
          <div className='d-flex d-lg-none justify-content-center mt-5'>
            <button
              type='button'
              className='btn text-white rounded-0 w-75'
              style={{ backgroundColor: '#3C86DD' }}
              onClick={() =>
                window.open(
                  'https://telegram.me/Intelisys',
                  '_blank',
                  'noreferrer'
                )
              }
            >
              Click here to join our official Telegram channel
            </button>
          </div>
          <div className='d-none d-lg-flex justify-content-lg-start mt-5'>
            <a
              href='https://telegram.me/Intelisys'
              target='_blank'
              rel='noreferrer'
            >
              <button
                type='button'
                className='btn text-white rounded-0'
                style={{ backgroundColor: '#3C86DD' }}
              >
                Click here to join our official Telegram channel
              </button>
            </a>
          </div>
        </div>
      </div> */}
      <Navbar fixed='bottom'>
        <TickerTape colorTheme='light' symbols={TickerTapeSymbols} />
      </Navbar>
      <div className='mb-5'>
        <Footer />
      </div>
    </>
  );
}

export default HomePage;
